import demo1 from "./demo1.png";
import demo2 from "./demo2.png";
import demo3 from "./demo3.png";

export { demo1, demo2, demo3 };



// WEBPACK FOOTER //
// ./src/static/images/index.js